import React from 'react';
import { numberStringOrDash } from '../D3/Common/utils';
const isDemo = process.env.REACT_APP_THEME === 'demo';
const accentColor = isDemo ? '#3aa6b9' : '#9C27B0';
class ScoreCircle extends React.Component {
  render() {
    const { score, grade, rawScore } = this.props;

    // Calculate the stroke dash array for the progress
    const radius = 30;
    const circumference = 2 * Math.PI * radius;
    const strokeDasharray = circumference;
    const strokeDashoffset = circumference - (score / 100) * circumference;

    return (
      <div
        style={{
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          marginBottom: '20px',
        }}
      >
        <h2
          style={{
            marginBottom: '0px',
            fontWeight: 'bold',
            color: accentColor, // demo: brand cyan/primary; prod: purple
            fontSize: '14px',
            margin: '5px 0 0px 0',
          }}
        >
          Overall Rating
        </h2>

        <div
          style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 5px auto',
            position: 'relative',
          }}
        >
          <svg width="80" height="80" style={{ transform: 'rotate(-90deg)' }}>
            {/* Background circle */}
            <circle
              cx="40"
              cy="40"
              r={radius}
              fill="none"
              stroke="#D0D0D0" // Light gray trail
              strokeWidth="8"
            />
            {/* Progress circle */}
            <circle
              cx="40"
              cy="40"
              r={radius}
              fill="none"
              stroke={accentColor} // demo: brand cyan/primary; prod: purple
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              style={{
                transition: 'stroke-dashoffset 1s ease-in-out',
              }}
            />
          </svg>

          {/* Grade text in center */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '24px',
              fontWeight: 'bold',
              color: accentColor, // demo: brand cyan/primary; prod: purple
            }}
          >
            {numberStringOrDash(grade)}
          </div>
        </div>

        <p
          style={{
            marginTop: '5px',
            fontWeight: 'bold',
            color: accentColor, // demo: brand cyan/primary; prod: purple
            fontSize: '14px',
            margin: '0',
          }}
        >
          {numberStringOrDash(score)} out of 100
        </p>

        {rawScore && (
          <p
            style={{
              marginTop: '5px',
              fontWeight: 'normal',
              color: '#999', // Light gray color
              fontSize: '14px',
              margin: '5px 0 0 0',
            }}
          >
            Raw Score: {numberStringOrDash(rawScore)}
          </p>
        )}
      </div>
    );
  }
}

export default ScoreCircle;
